import { ArrowTopRightOnSquareIcon } from "@heroicons/react/16/solid"
import type { DockItem } from "@src/providers/ActivityDockProvider"
import clsx from "clsx"
import { motion } from "framer-motion"
import { cloneElement, isValidElement } from "react"
import Button from "./Button"

export function DockCard({
  item,
  isFirst,
}: {
  item: DockItem
  isFirst: boolean
}) {
  return (
    <motion.div
      exit={{ opacity: 0, height: 0 }}
      transition={{
        duration: 0.2,
      }}
    >
      <div className={clsx(!isFirst && "pt-4")}>
        <div className="-outline-offset-1 w-full rounded-2xl bg-white p-3 outline-1 outline-gray-900/15 dark:bg-gray-800 dark:outline-white/5">
          <div className="flex items-center gap-2">
            <div className="-space-x-2.5 flex shrink-0 items-center">
              {item.icons.map((icon, idx) => {
                if (!isValidElement<{ className?: string }>(icon)) return null

                return cloneElement(icon, {
                  key: `${item.id}-icon-${idx}`,
                  className: clsx(
                    icon.props.className,
                    "rounded-full ring-2 ring-white dark:ring-gray-800"
                  ),
                })
              })}
            </div>
            <p className="flex-1 font-semibold text-gray-700 text-sm dark:text-white">
              {item.title}
            </p>
          </div>

          {item.renderContent ? (
            <div className="mt-4">{item.renderContent()}</div>
          ) : (
            item.keyValueRows.length > 0 && (
              <dl className="mt-4 space-y-2 overflow-hidden">
                {item.keyValueRows.map((row) => (
                  <div
                    key={row.label}
                    className="flex items-center justify-between gap-3"
                  >
                    <dt className="whitespace-nowrap font-medium text-gray-500 text-sm dark:text-gray-400">
                      {row.label}
                    </dt>
                    <dd className="truncate whitespace-nowrap font-semibold text-gray-900 text-sm dark:text-white">
                      {row.value}
                    </dd>
                  </div>
                ))}
              </dl>
            )
          )}

          {item.explorerUrl && (
            <Button
              href={item.explorerUrl}
              variant="primary"
              target="_blank"
              rel="noopener noreferrer"
              fullWidth
              className="mt-4"
            >
              View on explorer
              <ArrowTopRightOnSquareIcon className="size-4" />
            </Button>
          )}
        </div>
      </div>
    </motion.div>
  )
}
